import React from 'react';
import KitLandingLayout from './KitLandingLayout';

const config = {
  slug: 'legalbot',
  name: 'LegalBot',
  breadcrumb: 'Kit LegalBot',
  industry: 'estudios jurídicos y abogados',
  seoTitle: 'LegalBot — Asistente WhatsApp para Estudios Jurídicos',
  seoDescription: 'Consultas legales, agenda de reuniones y seguimiento de causas PJUD por WhatsApp. IA para abogados y estudios jurídicos.',
  accent: 'indigo',
  accentHex: '#4F46E5',
  heroEmoji: '⚖️',
  title: 'LegalBot — tu estudio jurídico disponible 24/7',
  tagline:
    'LegalBot atiende consultas legales por WhatsApp, agenda reuniones con los abogados y monitorea el avance de causas en el PJUD. Tus clientes tienen un punto de contacto siempre disponible.',
  stats: [
    { value: '24/7', label: 'atención automática' },
    { value: 'PJUD', label: 'monitoreo activo' },
    { value: '0', label: 'llamadas para agendar' },
  ],
  features: [
    { title: 'Consultas legales iniciales', body: 'Responde preguntas frecuentes y orienta al cliente antes de derivar al abogado.' },
    { title: 'Agenda de reuniones', body: 'Disponibilidad real en Google Calendar, confirmación + recordatorio automático.' },
    { title: 'Seguimiento de causas PJUD', highlight: true, body: 'Monitorea el estado de las causas y notifica al cliente cuando hay novedades.' },
    { title: 'Notificaciones por email', body: 'Al estudio y al cliente cuando se agenda una reunión o cuando hay movimiento en una causa.' },
    { title: 'Información sobre requisitos', body: 'Explica qué documentos necesita el cliente según el tipo de trámite.' },
    { title: 'Multi-abogado', body: 'Dirige la consulta al especialista correcto o asigna por disponibilidad.' },
  ],
  practiceAreas: [
    'Derecho de familia',
    'Derecho laboral',
    'Derecho civil',
    'Derecho penal',
    'Derecho comercial',
    'Derecho tributario',
  ],
  flowSubtitle: 'De la consulta inicial al seguimiento de causa, sin intervenir manualmente.',
  flow: [
    { title: 'Escribe por WhatsApp', body: 'LegalBot se presenta como asistente del estudio.' },
    { title: 'Responde la consulta inicial', body: 'Información general, documentos necesarios y pasos a seguir.' },
    { title: 'Agenda reunión con el abogado', highlight: true, body: 'Google Calendar real, confirmación + recordatorio + email al estudio.' },
    { title: 'Hace seguimiento de causas PJUD', body: 'Notifica al cliente cuando hay movimientos nuevos en su expediente.' },
    { title: 'El abogado se enfoca en lo que importa', body: 'Consultas simples y seguimiento quedan automatizados.' },
  ],
  mockup: {
    left: {
      title: 'Causas activas',
      subtitle: 'Monitoreo PJUD',
      rows: [
        { primary: 'C-1024-2026 · Familia', secondary: 'Cliente: María Soto · Alimentos', status: 'Novedad' },
        { primary: 'C-0876-2026 · Laboral', secondary: 'Cliente: Juan Pérez · Despido', status: 'Al día' },
        { primary: 'C-1103-2026 · Civil', secondary: 'Cliente: Ana Ríos · Arriendos', status: 'Pendiente' },
        { primary: 'C-0754-2026 · Familia', secondary: 'Cliente: Luis Vega · Divorcio', status: 'Al día' },
      ],
    },
    right: {
      title: 'Agenda del día',
      action: 'Ver semana',
      rows: [
        { primary: '10:00 — Carlos Muñoz', secondary: 'Derecho laboral · consulta inicial', badge: 'Confirmado' },
        { primary: '12:30 — María Soto', secondary: 'Derecho de familia · alimentos', badge: 'Confirmado' },
        { primary: '15:00 — Rodrigo Silva', secondary: 'Derecho comercial · contrato', badge: 'Pendiente' },
        { primary: '17:30 — Valentina Rojas', secondary: 'Derecho civil · arriendos', badge: 'Confirmado' },
      ],
    },
  },
  onboardingBanner: {
    title: 'LegalBot requiere configuración personalizada',
    body: 'Por la complejidad técnica del kit (integración PJUD, Google Calendar, notificaciones por email y configuración del perfil legal del estudio), LegalBot incluye un proceso de onboarding asistido. Al contratar, un especialista de ACBotHub te contactará para configurarlo juntos.',
  },
  useCases: [
    'Abogados independientes',
    'Estudios jurídicos',
    'Causas con seguimiento activo',
    'Primera consulta automatizada',
  ],
};

export default function LegalBotKitPage() {
  return <KitLandingLayout config={config} />;
}
